// this used to communicate close from the webpage to the mobile devices (~currently used to close the webview)
/* eslint-disable */

import { forEach, snakeCase } from 'lodash';
import { Cookies } from 'react-cookie';

import getEnvironment from '../../config/environment';

const cookies = new Cookies();

export function closeWebView(data: any) {
  forEach(data, (value, key) => {
    cookies.set(snakeCase(key), value);
  });

  try {
    (globalThis as any).Android?.closeForm();
  } catch (e) {
    if (!getEnvironment().isProd) console.log(e);
  }
  try {
    (window as any).webkit.messageHandlers.closeFormHandler.postMessage('close');
  } catch (err) {
    if (!getEnvironment().isProd) console.log('The native context does not exist yet');
  }
}
